import get from 'lodash/get';
import store from '../../store/store';
import { invokeService } from '../../service';

const LOGERROR = '/utilities/error/logerror';

// FIXED: Convert to proper Redux action creators
export const logErrorSuccess = (data, message) => ({
  type: 'LOG_ERROR_SUCCESS',
  payload: {
    data,
    message,
    timestamp: new Date().toISOString(),
  }
});

const logErrorFailure = (error = null) => ({
  type: 'LOG_ERROR_FAILURE',
  payload: {
    error: error?.message || 'Failed to log error',
    timestamp: new Date().toISOString(),
  }
});

// FIXED: Add loading action
const logErrorPending = () => ({
  type: 'LOG_ERROR_PENDING',
  payload: {
    timestamp: new Date().toISOString(),
  }
});

/** Dispatches Error Response Object */
export const logErrorMessage = (error, businessFunc) => async (dispatch) => {
  // Dispatch pending action
  dispatch(logErrorPending());
  
  try {
    // Check if LOGERROR URL is available
    if (!LOGERROR) {
      console.warn('Error logging service URL not configured. Error:', error);
      dispatch(logErrorFailure(new Error('Error logging service URL not configured')));
      return;
    }
    
    const url = `${LOGERROR}`;

    const customerDetails = localStorage.getItem('_customerDetails');
    const {
      locale = '',
      memberId = '',
      memberTierType = '',
    } = customerDetails ? JSON.parse(customerDetails) : {};

    const requestBody = {
      application: 'WOW',
      browser: window.navigator.vendor,
      businessFunction: businessFunc || '',
      channel: 'WEB',
      customerId: memberId,
      errorCode: get(error, 'error.response.data.code', ''),
      errorMessage: get(error, 'error.response.data.message', ''),
      errorStacktrace: '',
      errorType: 'System',
      lineOfBusiness: memberTierType,
      locale: locale,
      pageName: store.getState().CommonReducer?.pageName || '',
      productType: '',
      request: `${get(error, 'error.config.url', '')} ${get(error, 'error.config.data', '')}`,
      requestId: get(error, 'error.response.headers.traceid', ''),
      response: get(error, 'error.stack', ''),
      serverName: window.location.host,
      sessionId: '',
      tealeafId: '',
      userIP: '',
    };

    // Call the service
    const serviceResponse = await invokeService({
      resource: url,
      method: 'POST',
      data: requestBody,
    });

    // FIXED: Dispatch proper actions based on response
    if (serviceResponse) {
      dispatch(logErrorSuccess(serviceResponse, requestBody.errorMessage));
    } else {
      dispatch(logErrorFailure(new Error('Service returned empty response')));
    }
  } catch (serviceError) {
    console.error('Error in logErrorMessage service call:', serviceError);
    dispatch(logErrorFailure(serviceError));
  }
};
